<style lang="scss" scoped>
/deep/ .ivu-input{
    cursor: pointer;
}
</style>
<template>
    <section class="margin-15">
        <compFormEdit ref="formbase" class="margin-layout" :formdata="getBase" v-model="formData" ></compFormEdit>
        <vButtonGroup class="text-right">
            <vButton theme="primary" @click="add">{{$t("fbb.headlogistics.next_step", { defaultValue: "下一步" })}}</vButton>
            <vButton @click="cancel">{{$t("global.common.return", { defaultValue: "返回" })}}</vButton>
        </vButtonGroup>
        <vModal v-model="modalProps.show" :title="modalProps.title" :width="modalProps.width" :showFooter="false">
            <component :is="modalProps.component" @on-close="modalProps.show = false" v-on="modalProps.on" v-bind="modalProps.props"></component>
        </vModal>
        <vLoading size="large" transfer :loading="loading"></vLoading>
    </section>
</template>

<script>
import { HttpMarkChangeOrderSave } from "@/service/misc";
import compPlanbill from "./planbill";
import { mapGetters } from 'vuex';
export default {
    components: {
        compFormEdit: () => import("@components/templates/formedit"),
        compPlanbill,
    },
    data() {
        return {
            formData: {},
            loading: false,
            modalProps: {
              show: false,
            },
        };
    },

    computed: {
		...mapGetters('dictionary', ['getCusproductList', 'getUserManageWarehouseList', 'getFilterDisabledWarehouse']),
        getBase() {
            return [
                {
                    label: this.$t('fbb.markchange.exchange_plan_no', { defaultValue: "换标上架计划单号" }),
                    key: "changeLabelPlanNo",
                    tag: "div",
                    children: (h) => {
                        return <div onClick={this.handleModal.bind(this)}>
                            <Input style="cursor: pointer;" value={this.formData.changeLabelPlanNo} readonly >
                                <Icon style="cursor: pointer;" slot="suffix" type="md-search" nativeOnClick={this.handleModal.bind( this )}></Icon>
                            </Input>
                        </div>
                    },
                    style: "margin-bottom: -2px;",
                },
                {
                    label: this.$t("global.common.source_number", { defaultValue: "来源单号" }),
                    key: "sourceNo",
                    required: false,
                },
                {
                    label: this.$t("global.common.project", { defaultValue: "项目" }),
                    tag: 'vSelect',
                    key: "lineId",
                    options: this.getCusproductList.map((item) => {
                        return {
                            value: item.value,
                            label: item.attach.name,
                        }
                    }),
                    query: true,
                },
                {
                    label: this.$t("global.common.warehouse", { defaultValue: "仓库" }),
                    key: 'orgWarehouseId',
                    tag: 'vSelect',
                    options: this.getUserManageWarehouseList.map(item=>{
                        return {
                            label:item.label,
                            value:item.attach.id
                        }
                    }),
                    query: true,
                },
                {
                    label: this.$t("global.common.notes", { defaultValue: "备注" }),
                    tag: "vTextarea",
                    key: "remark",
                    required: false,
                },
            ];
        },
    },
    methods: {
        add() {
            const { sourceNo, id, remark, changeLabelPlanNo} = this.formData;
            if (!changeLabelPlanNo) {
                return this.$Message.warning({
                    content: this.$t('fbb.markchange.exchange_plan_no_check', { defaultValue: "换标上架计划单号不能为空！"} ),
                    duration: 30,
                    closable: true,
                });
                // this.$VMessage.warning(
                //     this.$t('fbb.markchange.exchange_plan_no_check', { defaultValue: "换标上架计划单号不能为空！"} )
                // );
            }
            this.loading = true;
            HttpMarkChangeOrderSave({ changeLabelPlanId: id, sourceNo, remark,})
                .then((res) => {
                    this.$router.push({
                        name: "markChangeOrderDetail",
                        params: {
                          type: "edit",
                        },
                        query: {
                          id: res.data.id,
                        },
                    });
                })
            .catch((err) => {
                this.loading = false;
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true,
                });
            });
        },
        handleModal() {
            this.modalProps = {
                show: true,
                width: 1000,
                title: this.$t('fbb.markchange.find_replace_plan', { defaultValue: "查找换标上架计划" }),
                component: "compPlanbill",
                on: {
                    "on-data": (row) => {
                        this.formData = row;
                        this.modalProps = {};
                    },
                },
            };
        },
        cancel() {
            this.$emit("on-close");
        },
    },
};
</script>
